export namespace CookieScriptsUtil {
  export function createHeadScript(document: Document, scriptSrc: string, scriptId?: string): Promise<Event> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      if (scriptId) {
        script.id = scriptId;
      }
      script.src = scriptSrc;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
}
